import { Navigate, Outlet } from 'react-router-dom'

import { useAppSelector } from '@/hooks/reduxHooks'
import Loader from '@/components/Loader'
import { readToken } from '@app/store/services/local-storage.service'

interface ProtectedRouteProps {
  requiredRoles?: string[]
}

const ProtectedRoute = ({ requiredRoles = [] }: ProtectedRouteProps) => {
  const { data: profile, status } = useAppSelector((state) => state.profile)
  const token = readToken()

  if (!token) {
    return <Navigate to='/auth/login' replace />
  }

  const isProfilePending = status === 'loading' || (!profile && status === 'idle')

  if (isProfilePending) {
    return (
      <div className='flex items-center justify-center min-h-screen'>
        <Loader size='48' />
      </div>
    )
  }

  if (!profile || status === 'failed') {
    return <Navigate to='/auth/login' replace />
  }

  const userRoles = Array.isArray(profile.role) ? profile.role : [profile.role].filter(Boolean)
  const hasRequiredRole =
    requiredRoles.length === 0 || requiredRoles.some((requiredRole) => userRoles.includes(requiredRole))

  if (!hasRequiredRole) {
    return <Navigate to='/dashboard' replace />
  }

  return <Outlet />
}

export default ProtectedRoute
